import renderer from "dom-serializer";
import * as htmlparser2 from "htmlparser2";

function encodeSpecialCharacters(htmlContent: string) {
    const dom = htmlparser2.parseDocument(htmlContent);
    return renderer(dom);
}

export default function transformContentHtml(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }

    htmlContent = encodeSpecialCharacters(htmlContent);

    const bodyStart = htmlContent.indexOf("<body");
    const bodyEnd = htmlContent.indexOf("</body>");

    if (bodyStart >= 0 && bodyEnd >= 0) {
        const bodyStartClosing = htmlContent.indexOf(">", bodyStart);
        return htmlContent.substring(bodyStartClosing + 1, bodyEnd);
    }

    const htmlStart = htmlContent.indexOf("<html");
    const htmlEnd = htmlContent.indexOf("</html>");

    if (htmlStart < 0 || htmlEnd < 0) {
        return htmlContent;
    }

    const htmlStartClosing = htmlContent.indexOf(">", htmlStart);
    return htmlContent.substring(htmlStartClosing + 1, htmlEnd);
}
